import { render, staticRenderFns } from "./unReceivedRmaList.vue?vue&type=template&id=a15ad9a6&scoped=true"
import script from "./unReceivedRmaList.vue?vue&type=script&lang=js"
export * from "./unReceivedRmaList.vue?vue&type=script&lang=js"
import style0 from "./unReceivedRmaList.vue?vue&type=style&index=0&id=a15ad9a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a15ad9a6",
  null
  
)

export default component.exports